export default __webpack_public_path__ + "static/Mont-Regular-1d26d89f7339866d31337b4cad51b491.otf";